/* eslint-disable import/no-mutable-exports */
let BLOCKS = {};

export function loadBlocks(locales) {
  BLOCKS = {
    establishmentAndClass: {
      title: locales.admin.establishmentAndClass,
      children: [
        { key: 'establishmentsCount', title: locales.admin.establishment },
        { key: 'totalClassrooms', title: locales.admin.classes },
        { key: 'activeClassrooms', title: locales.admin.activeClasses },
      ],
    },
    adminsAndEducators: {
      title: locales.admin.adminsAndEducators,
      children: [
        { key: 'totalTracksAdminAndLecturers', title: locales.admin.total },
        {
          key: 'totalActiveAdminAndLecturers',
          title: locales.admin.activeLast30Days,
        },
      ],
    },
    students: {
      title: locales.admin.students,
      children: [
        { key: 'totalProject', title: locales.admin.totalProjects },
        { key: 'totalStudents', title: locales.admin.totalStudents },
        {
          key: 'totalLastActiveStudents',
          title: locales.admin.activeLast30Days,
        },
      ],
    },
    activity: {
      title: locales.admin.activity,
      children: [
        { key: 'totalSiteTimeTracks', title: locales.admin.totalMinutes },
        {
          key: 'totalSiteLastTotalTracks',
          title: locales.admin.minutesLast30Days,
        },
      ],
    },
    totalProgress: {
      title: locales.admin.totalProgress,
      children: [
        { key: 'ideasCount', title: locales.admin.ideasCreated },
        { key: 'canvasProgress', title: locales.admin.canvasProgress },
        { key: 'testsCompleted', title: locales.admin.testsCompleted },
      ],
    },
    licences: {
      title: locales.admin.licenses,
      children: [
        { key: 'totalLiveLicenses', title: locales.admin.liveLicenses },
        { key: 'totalExpiredLicenses', title: locales.admin.expiredLicenses },
      ],
    },
    classes: {
      title: locales.admin.classes,
      children: [
        { key: 'totalClassrooms', title: locales.admin.total },
        { key: 'activeClassrooms', title: locales.admin.activeLast30Days },
      ],
    },
    subscriptionAndLicence: [
      {
        title: locales.admin.subscription,
        value: '',
        children: [
          { key: 'licenseStartDate', title: locales.admin.licenseStartDate },
          { key: 'licenseEndDate', title: locales.admin.licenseEndDate },
        ],
      },
      {
        title: locales.admin.licenses,
        value: '',
        children: [
          { key: 'purchasedUserCount', title: locales.admin.total },
          { key: 'usedUsersCount', title: locales.admin.used },
          { key: 'remainingLicensesCount', title: locales.admin.remaining },
        ],
      },
    ],
  };
}

export { BLOCKS };
